import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { DebitCardDTO } from 'src/app/core/models/card';
import { AuthService } from 'src/app/core/services/shared-services/auth.service';
import { CardStatus } from 'src/app/shared/app.enums';
import { AppUtils } from '../../app-utils';
import { CardService } from '../card.service';
import { MemberService } from '../member.service';

@Injectable()
export class PermissionGuard implements CanActivateChild {
  constructor(
    private authService: AuthService,
    private memberService: MemberService,
    private cardService: CardService,
    private router: Router
  ) {}

  async getMemberData(): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
      this.memberService.member$.subscribe(memberDetails => {
        if (memberDetails) {
          resolve(memberDetails);
        }
      });
    });
  }

  private async hasActiveCard(): Promise<boolean> {
    const cards: DebitCardDTO[] = await firstValueFrom(this.cardService.cards$);
    return (cards ?? []).some(card => card?.statusDescription === CardStatus.Active);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<any>((resolve, reject) => {
      this.getMemberData().then(async res => {
        if (res) {
          // Below is claims only role check, now we are also checking for active card to display cards tab for claims only role.
          if (!res?.trnIsAllow && !res?.prkIsAllow) {
            if (AppUtils.isInRoles('LsaRole') || AppUtils.isInRoles('CRRole')) {
              if (state.url.startsWith('/card') && (await this.hasActiveCard())) {
                resolve(true);
                return;
              }
              this.router.navigateByUrl('/dashboard/home');
              resolve(false);
              return;
            } else {
              // this.router.navigateByUrl('/elect-benefits/home');
              resolve(true);
              return;
            }
          } else {
            resolve(true);
          }
        } else {
          resolve(false);
        }
      });
    });
  }
}
